// extracted by mini-css-extract-plugin
module.exports = {"input":"SearchInput_input__2wCi4","search-input-container":"SearchInput_search-input-container__LC7rq","search-icon":"SearchInput_search-icon__1FNkr"};